import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { Loan } from '../../generated/graphql';

export interface LoanSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'contentPrefix' | 'motionProps'
  > {
  itemTitle?: string;
  loan: Loan;
  onItemClicked?: (a: { loan: Loan }) => void;
}

export const LoanSumTableItem = ({ loan, onItemClicked, ...props }: LoanSumTableItemProps) => {
  return (
    <AmountSumTableItem
      linkStatus={loan.linkStatus}
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={loan.id}
      title={props.itemTitle ?? loan.name}
      dataTestID={loan.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={loan.ownedBalance}
      className={props.className}
      onClick={() => onItemClicked?.({ loan })}
      lastUpdated={latestDataPointGroupUpdateDateTime(loan.balance)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ loan })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(loan.balance), decayedLimit.Loan)}
    />
  );
};
